import React from "react";
import { CircularProgress } from "@mui/material";

const Loading = () => {
    return (
        <>
            <>Loading data. Please wait...</>
            <CircularProgress />
        </>
    );
}

export default Loading;